// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { PageErrorWrapper, PageErrorWrapperStyles } from "@insite/content-library/Components/PageErrorWrapper";
import OrderLayout from "@store/Library/Components/Toolkit/Layout/OrderLayout";
import useQueryString from "@toolkit/Framework/Common/Hooks/useQueryString";
import { useOrderApprovalsState } from "@toolkit/Framework/Store/Data/OrderApprovals/OrderApprovalsHooks";
import React from "react";

export interface OrderApprovalDetailsPageContainerStyles {
    pageErrorWrapper?: PageErrorWrapperStyles;
}

export const orderApprovalDetailsPageContainerStyles: OrderApprovalDetailsPageContainerStyles = {};

const styles = orderApprovalDetailsPageContainerStyles;

const OrderApprovalDetailsPageContainer = ({ id }: WidgetProps) => {
    const { cartId } = useQueryString();
    const orderApprovalsState = useOrderApprovalsState(cartId);

    return (
        <PageErrorWrapper
            value={orderApprovalsState}
            extendedStyles={styles.pageErrorWrapper}
            badRequestMessage={siteMessage("OrderApproval_BadRequest")}
            notAuthorizedMessage={siteMessage("OrderApproval_NotAuthorized")}
            notFoundMessage={siteMessage("OrderApproval_NotFound")}
        >
            <OrderLayout id={id} />
        </PageErrorWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderApprovalDetailsPageContainer,
    definition: {
        displayName: "Page Container",
        group: "Order Approval Details",
        allowedContexts: ["OrderApprovalDetailsPage"],
    },
};
export default widgetModule;
